import { render, staticRenderFns } from "./BaixaItemBemPermanenteForm.vue?vue&type=template&id=e2a91dbc&scoped=true"
import script from "./BaixaItemBemPermanenteForm.vue?vue&type=script&lang=js"
export * from "./BaixaItemBemPermanenteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a91dbc",
  null
  
)

export default component.exports